export function communitiesMap() {
    let googleMap = $('#map');
    let markerPin = googleMap.data("marker");
    let markerPinActive = googleMap.data("marker-active");
    let locations = $(".communities-list .item");
    initMap();

    function initMap() {
        let markers = [];
        let mapStyle = [
            {
                "featureType": "all",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "weight": "2.00"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#9c9c9c"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#7b7b7b"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#46bcec"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#c8d7d4"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#070707"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            }
        ];
        let map = new google.maps.Map(document.getElementById('map'), {
            styles: mapStyle,
            maxZoom: 18,
            scrollwheel: false,
            scaleControl: false,
            draggable: !(typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1),
            panControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            fullscreenControl: false,
            center: new google.maps.LatLng(locations.data("lat"), locations.data("lng"))
        });
        let bounds = new google.maps.LatLngBounds();
        let infowindow = new google.maps.InfoWindow();
        let marker = void 0,
            i = void 0;

        locations.each(function () {
            let $this = $(this);
            let lat = $this.data("lat");
            let lng = $this.data("lng");
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: markerPin
                // title: locations[i].state
            });
            markers.push(marker);
            bounds.extend(marker.position);
            google.maps.event.addListener(marker, 'click', function (marker, i) {
                let infoWindowContent = "<div class='info-window'>" + "<h5>" + $this.find("h4").text() + "</h5>" + "<p>" + $this.data("subtext") + "</p>" + "<a class='custom-link' href=" + $this.find("a").attr("href") + "><span>Visit Website<svg width='19' height='10' viewBox='0 0 19 10' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M11.7979 10V5.50562H0.5V4.49438H11.7979V0L18.5 4.98876L11.7979 10Z' fill='white'/></svg></span></a>" + "</div>";
                return function () {
                    for (let j = 0; j < markers.length; j++) {
                        markers[j].setIcon(markerPin);
                    }
                    infowindow.setContent(infoWindowContent);
                    infowindow.open(map, marker);
                    marker.setIcon(markerPinActive);
                };
            }(marker, i));

            google.maps.event.addListener(infowindow, 'closeclick', function (marker, i) {
                return function () {
                    marker.setIcon(markerPin);
                };
            }(marker, i));

            if (locations.length < 2) {
                map.setZoom(16);
            } else {
                map.fitBounds(bounds);
            }
        });
    }
    let communities = $('.communities-list-holder');
    if (communities.length) {
        communities.on('click', '.wp-pagenavi a', function (e) {
            e.preventDefault();

            let _this = $(this);
            let ajax_url = ajaxvars.ajaxurl;
            let data = {
                'action': 'pagination_communities',
                'data': communities.attr('data-communities-pages'),
                'paged': _this.attr('data-paged')
            };

            $.ajax({
                type: "POST",
                url: ajax_url,
                data: data,
                success: function (response) {
                    if (response) {
                        let content = $(response);
                        content.css({'opacity': 0});
                        communities.html(content);
                        locations = communities.find(".communities-list .item");
                        initMap();
                        window.initPagination();
                        content.animate({'opacity': 1}, 300);
                        $("html, body").animate({scrollTop: communities.offset().top - $('.header').innerHeight() * 1.5}, 500);
                    }
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/communitiesMap.js